/**
 * Ошибки админ-панели → POST /client-errors (оповещение в служебный чат).
 * URL без query/hash, не более 5 отчётов за загрузку, в разработке выключено.
 */
import { Component, type ErrorInfo, type ReactNode } from 'react';

const API_URL = (import.meta.env.VITE_API_URL || '').replace(/\/$/, '');
const sent = new Set<string>();

export function reportClientError(error: unknown, kind: 'error' | 'unhandledrejection' | 'render') {
  if (import.meta.env.DEV || import.meta.env.VITE_ERROR_REPORTING === 'false' || !API_URL) return;
  const err = error instanceof Error ? error : new Error(String(error ?? 'unknown'));
  const key = `${kind}|${err.message}`;
  if (sent.has(key) || sent.size >= 5) return;
  sent.add(key);
  try {
    void fetch(`${API_URL}/client-errors`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      keepalive: true,
      body: JSON.stringify({
        app: 'admin',
        kind,
        message: (err.message || err.name).slice(0, 2000),
        stack: err.stack?.slice(0, 8000),
        url: `${location.origin}${location.pathname}`,
        release: import.meta.env.VITE_RELEASE || undefined,
        userAgent: navigator.userAgent.slice(0, 400),
      }),
    }).catch(() => undefined);
  } catch {
    /* игнорируем */
  }
}

export function installGlobalErrorHandlers() {
  window.addEventListener('error', (e) => {
    if (e.error || e.message) reportClientError(e.error ?? e.message, 'error');
  });
  window.addEventListener('unhandledrejection', (e) => reportClientError(e.reason, 'unhandledrejection'));
}

export class ErrorBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  state = { failed: false };
  static getDerivedStateFromError() {
    return { failed: true };
  }
  componentDidCatch(error: Error, info: ErrorInfo) {
    const e = new Error(error.message);
    e.name = error.name;
    e.stack = `${error.stack ?? ''}\nComponent stack:${info.componentStack ?? ''}`.slice(0, 8000);
    reportClientError(e, 'render');
  }
  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div className="login" role="alert">
        <h1>Ошибка интерфейса</h1>
        <p>Отчёт отправлен. Перезагрузите страницу; если ошибка повторяется — сообщите разработчикам.</p>
        <button type="button" className="btn" onClick={() => location.reload()}>Перезагрузить</button>
      </div>
    );
  }
}
